import { relations } from 'drizzle-orm'
import { pgEnum, pgTable, text } from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getNullableIdReference,
  typedJsonb,
} from '../common/utils'
import { users } from './user'

// What one queue row is. 'person' = the B2C queue (one row per contactable
// human). 'customer' = the B2B queue (one row per taloyhtiö, with the operator
// choosing which contact to call).
export const callingCampaignQueueModeEnum = pgEnum(
  'calling_campaign_queue_mode',
  ['person', 'customer'],
)

export const callingCampaigns = pgTable(
  'calling_campaigns',
  {
    ...getBaseFields(),
    name: text().notNull(),
    description: text(),
    audienceFilter: typedJsonb('audience_filter').notNull(),
    // Which bookable service this campaign sells (a ServicePresetKey). Drives
    // the availability preview and the pre-filled booking in the workspace.
    // NULL = campaign isn't tied to one service, so no preview is offered.
    servicePresetKey: text(),
    createdById: getNullableIdReference(() => users.id),
    // NULL or empty/whitespace = no pre-call SMS for this campaign — the
    // template doubles as the on/off signal.
    preCallSmsTemplate: text(),
    queueMode: callingCampaignQueueModeEnum().notNull().default('person'),
  },
  (table) => getBaseIndexes('calling_campaigns', table),
)

export const callingCampaignsRelations = relations(
  callingCampaigns,
  ({ one }) => ({
    createdBy: one(users, {
      fields: [callingCampaigns.createdById],
      references: [users.id],
    }),
  }),
)
